import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/confirmacao-exame`

    return {
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        datatable(queryParams) {
            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParams)}`)
        },
        totalizadores(queryParams) {
            return repository.get(`${baseUrl}/totalizadores?${urlUtil.serialize(queryParams)}`)
        },
        list(queryParams) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParams)}`)
        },
        confirmar(grupoId) {
            return repository.post(`${baseUrl}/${grupoId}/confirmar`)
        },
    }
}
